var _ua = (function (u) {
  return {
    Tablet: (u.indexOf("windows") != -1 && u.indexOf("touch") != -1) || u.indexOf("ipad") != -1 || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1) || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1) || u.indexOf("kindle") != -1 || u.indexOf("silk") != -1 || u.indexOf("playbook") != -1,
    Mobile: (u.indexOf("windows") != -1 && u.indexOf("phone") != -1) || u.indexOf("iphone") != -1 || u.indexOf("ipod") != -1 || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1) || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1) || u.indexOf("blackberry") != -1
  }
})(window.navigator.userAgent.toLowerCase());

if (_ua.Mobile) {
  document.write('<meta name="viewport" content="width=device-width,user-scalable=yes,minimum-scale=1,maximum-scale=1">')
} else if (_ua.Tablet) {
  document.write('<meta name="viewport" content="width=1340">')
} else { }

jQuery(function ($) {
  // Anchor link
  $(document).on('click', 'a.anchor[href*="#"]', function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var $target = $(this.hash);
      $target = $target.length && $target || $('[name=' + this.hash.slice(1) + ']');
      if ($target.length) {
        var targetOffset = $target.offset().top;
        $('html,body').animate({ scrollTop: targetOffset }, 1500);
        return false;
      }
    }
  });

  $(document).on('click', '.page_inner_nav_ul a[href*="#"]', function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var $target = $(this.hash);
      $target = $target.length && $target || $('[name=' + this.hash.slice(1) + ']');
      if ($target.length) {
        var targetOffset = $target.offset().top;
        $('html,body').animate({ scrollTop: targetOffset - 54 }, 1500);
        return false;
      }
    }
  });

  $(document).on('click', '.rscFeatureItems a[href*="#"]', function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var $target = $(this.hash);
      $target = $target.length && $target || $('[name=' + this.hash.slice(1) + ']');
      if ($target.length) {
        var targetOffset = $target.offset().top;
        $('html,body').animate({ scrollTop: targetOffset }, 1500);
        return false;
      }
    }
  });

  // Anchor link
  $('.pagetop a').on('click', function () {
    var targetOffset = 0;
    $('html,body').animate({ scrollTop: targetOffset }, 1000);
  });

  // Menu SP
  $('.hamburger').on('click.navsp', 'button', function () {
    $('body').toggleClass('nav--opened');
  });
  $('.has--sub > span').on('click', function (e) {
    if ($(window).width() < 768) {
      if (!$('.has--sub').hasClass('opened')) {
        $('body').addClass('subnav--opened');
      }
      $(this).parent().toggleClass('opened');
      $(this).next().slideToggle();
      if ($('.mainmenu > .opened').length < 1) {
        $('body').removeClass('subnav--opened');
      }
    }
  });

  $('.parent--nolink > a').on('click', function (e) {
    if ($(window).width() < 768) {
      e.preventDefault();
      if (!$('.parent--nolink').hasClass('opened')) {
        $('body').addClass('subnav--opened');
      }
      $(this).parent().toggleClass('opened');
      $(this).next().slideToggle();
      if ($('.mainmenu > .opened').length < 1) {
        $('body').removeClass('subnav--opened');
      }
    }
  });

  if ($(window).width() < 768) {
    var hnav = $('#nav').outerHeight() - 20;
    if ($(window).height() < hnav) { $('#nav').css('bottom', 0); }
  }

  // Slick
  if ($('.visual__slide').length) {
    $('.visual__slide').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000,
      centerMode: true,        //追記
      centerPadding: "15%",
      pauseOnHover: false,
      // appendArrows: $('#slick_arrow')
      prevArrow: '<img src="/img/common/arrow_left.png" class="slide-arrow prev-arrow">',
      nextArrow: '<img src="/img/common/arrow_right.png" class="slide-arrow next-arrow">',


      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          centerPadding: "0",
        },
      },
        // {
        //          breakpoint: 1360,
        //     settings: {
        //      slidesToShow: 1,
        //      centerMode: true,
        //      centerPadding: '10%',
        //    },
        //   },

      ]


    });
  }


  // store
  $('.filter__group > ul > li > a').on('click', function (e) {
    if ($(window).width() < 768) {
      e.preventDefault();
      $(this).toggleClass('opened');
      $(this).next().slideToggle();
    }
  });

  $('.listwrap > span').on('click', function (e) {
    $(this).next().slideToggle();
  });
  $('.category__list ul a').on('click', function (e) {
    if ($(window).width() < 768) {
      var t = $(this).attr('data-value');
      $(this).parents('.category__list').slideToggle();
      $('.listwrap > span').text(t);
      $('.category__list ul li').removeClass('active');
      $(this).parent().addClass('active');
    }
  });
  $('.category__list > a').on('click', function (e) {
    $(this).parent().slideToggle();
  });
  if ($('.product__image--main').length) {
    $('.product__image--main').slick({
      dots: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false
    }).on('afterChange', function (event, $slider, currentSlide) {
      $('.product__thumb').find(".slidethumb").removeClass('active');
      $('.product__thumb').find(".slidethumb").eq(currentSlide).addClass('active');
    });
  }
  $('.slidethumb').on('click', function () {
    var index = $(this).attr('data-index');
    $(this).parent().find(".slidethumb").removeClass('active');
    $(this).addClass('active');
    $('.product__image--main').slick('slickGoTo', index, false);
  });

  // Tabs
  $('.tablist li a').on('click', function () {
    $(this).parents('.tablist').find('li').removeClass('active');
    $(this).parent().addClass('active');
    var $id = $($(this).attr('data-id'));
    $('.tabitem').fadeOut();
    $id.fadeIn();
  });

  // detail
  function checkGiftbox() {
    var v = $('select#productoption2').val();
    if (v == '6') {
      $('.showtextarea4').fadeIn();
      $('.showtextarea5').fadeIn();
    } else if (v == '9') {
      $('.showtextarea4').fadeIn();
      $('.showtextarea5').fadeIn();
    } else {
      $('.showtextarea4').fadeOut();
      $('.showtextarea5').fadeOut();
    }
  }
  // detail
  function checkGift() {
    var v = $('select#productoption7').val();
    if (v == '12') {
      $('.showtextarea4').fadeIn();
      $('.showtextarea5').fadeIn();
    } else if (v == '13') {
      $('.showtextarea4').fadeIn();
      $('.showtextarea5').fadeIn();
    } else {
      $('.showtextarea4').fadeOut();
      $('.showtextarea5').fadeOut();
    }
  }
  function checkCard() {
    var v = $('select#productoption3').val();
    if (v == '7') {
      $('.showtextarea6').fadeIn();
    } else {
      $('.showtextarea6').fadeOut();
    }
  }
  if ($('select#productoption2').length) {

    //checkGift();
    $('select#productoption2').change(function () {
      checkGiftbox();
    });
  }
  if ($('select#productoption7').length) {
    //checkGift();
    $('select#productoption7').change(function () {
      checkGift();
    });
  }
  if ($('select#productoption3').length) {
    //checkCard();
    $('select#productoption3').change(function () {
      checkCard();
    });
  }

  $("#productoption4").attr('placeholder', '記入のない場合は、無記入のままお届けします。\n');
  $("#productoption5").attr('placeholder', '記入のない場合は、無記入のままお届けします。\n');
  $("#productoption6").attr('placeholder', '記入のない場合は、無記入のままお届けします。\n');

  // accordion
  $('.accordion-title a').on('click', function (e) {
    e.preventDefault();
    $(this).parent().parent().toggleClass('builder-accordion-active');
    $(this).parent().next('.accordion-content').slideToggle();
  });

  $('.tab-nav li a').click(function (e) {
    e.preventDefault();
    $(this).parents('.tab-nav').find('li').removeClass('current').attr('aria-expanded', 'false');
    $(this).parent().addClass('current').attr('aria-expanded', 'true');
    $('.btn6').removeClass('block');
    $('.btn7').removeClass('block');

    if ($(this).parent().hasClass('btn4')) { $('.btn6').addClass('block'); }
    if ($(this).parent().hasClass('btn7')) { $('.btn6').addClass('block'); }
    if ($(this).parent().hasClass('btn5')) { $('.btn7').addClass('block'); }
    if ($(this).parent().hasClass('btn6')) { $('.btn7').addClass('block'); }

    var $id = $($(this).attr('href'));
    $(this).parents('.builder-tabs-wrap').find('.tab-content').attr('aria-hidden', 'true');
    $id.attr('aria-hidden', 'false');
  });


  var w = $(window).width();
  var x = 768;
  if (w < x) {
    $("#submenu_btn").on("click", function () {

      var dt = $(this);
      var arrow = $(".store__nav--plus", this)
      dt.next().slideToggle(function () {
        if (dt.next().is(':visible')) {
          arrow.css("transform", "rotate(225deg)")
        }
        else {
          arrow.css("transform", "rotate(45deg)")
        }
      }
      );
    });
  } else {
    $(".submenu_btn").hover(function () {

      $("#submenu").stop().slideDown();
    }, function () {
      $("#submenu").slideUp();
    }
    );
  }

  $(function () {
    var elem = $(".rscFeatureDetail__modalLink");
    if (elem.size() > 0) {
      elem.colorbox({
        rel: 'slideshow',
        slideshow: false,
        inline: true,
        maxWidth: "90%",
        // maxHeight:"90%",
        opacity: 0.7
      });
    }
  });

});

var elem = $('.comparison-cleaner-slider');
if (elem.size() > 0) {
  elem.slick({
    dots: true,
  });
}


jQuery(window).scroll(function () {
  if (jQuery(".comparison-cleaner-slider").size() > 0) {
    let scrollTop = jQuery(window).scrollTop(); // スクロール上部の位置

    let areaTop = jQuery(".comparison-cleaner-slider").offset().top; // 対象エリアの上部の位置
    let areaBottom = areaTop + jQuery(".comparison-cleaner-slider").innerHeight(); // 対象エリアの下部の位置

    // if (scrollTop > areaTop && scrollTop < areaBottom) {
    //   jQuery(".slick-dots li,.slick-prev,.slick-next").addClass("is-in"); // スクロールが対象エリアに入った場合
    // } else {
    //   jQuery(".slick-dots li,.slick-prev,.slick-next").removeClass("is-in"); // スクロールが対象エリアから出ている場合
    // }
  }
});
